import { createContext } from 'react';

import { AssetLoaderContextProps } from '@mews/framework';

export const PlatformImageAssetLoaderContext = createContext<AssetLoaderContextProps>({});
